import { render, staticRenderFns } from "./WebhookLogs.vue?vue&type=template&id=b0393a4a&"
import script from "./WebhookLogs.vue?vue&type=script&lang=ts&"
export * from "./WebhookLogs.vue?vue&type=script&lang=ts&"
import style0 from "./WebhookLogs.vue?vue&type=style&index=0&id=b0393a4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports